module.exports = __webpack_public_path__ + "static/media/distraction-fish.a395ea0c.png";